<div class="delivery-all-awards-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="allAwards()"></grid-content>
</div>